import { useTranslation } from 'react-i18next';
import { getAccount } from '@/api';
import { LmtWidgetType } from '@/domain/live';
import { canShowMatchTracker } from '@/domain/lmt';
import { cn } from '@/lib/cn';
import { BetradarLmtWidget } from './BetradarLmtWidget';
import { TheSportsLmtWidget } from './TheSportsLmtWidget';

export interface LiveMatchTrackerProps {
  eventId: number;
  sport: string;
  matchTrackerEnabled: boolean;
  theSportsId?: string | null;
  className?: string;
}

export function LiveMatchTracker({
  eventId,
  sport,
  matchTrackerEnabled,
  theSportsId,
  className,
}: LiveMatchTrackerProps) {
  const { i18n } = useTranslation();
  const account = getAccount();
  const trackingType = account?.LiveMatchTrackingType ?? LmtWidgetType.None;
  const trackingKey = account?.LiveMatchTrackingKey?.trim() ?? '';

  // `matchTrackerEnabled` is kept on the props for callers/API parity but is not
  // used for gating — legacy LoadLiveWidget ignores MatchTrackerEnabled.
  void matchTrackerEnabled;

  if (
    !canShowMatchTracker({
      trackingType,
      trackingKey,
      theSportsId,
      sport,
    })
  ) {
    return null;
  }

  const language = i18n.language || 'en';

  return (
    <div
      data-container="livedetailswidget"
      className={cn('relative z-[1] flex w-full flex-col', className)}
    >
      <div
        className={cn(
          'w-full overflow-hidden bg-bg-surface leading-none',
          trackingType === LmtWidgetType.TheSports ? 'min-h-[315px]' : 'min-h-[245px]',
        )}
      >
        {trackingType === LmtWidgetType.Betradar ? (
          <BetradarLmtWidget eventId={eventId} language={language} className="h-full w-full" />
        ) : null}
        {trackingType === LmtWidgetType.TheSports ? (
          <TheSportsLmtWidget
            sport={sport}
            theSportsId={theSportsId ?? ''}
            profileKeys={trackingKey}
            language={language}
          />
        ) : null}
      </div>
    </div>
  );
}
